import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1b38ac28")

_pushScopeId("data-v-1b38ac28")
const _hoisted_1 = { class: "product-datasheet mt-8" }
const _hoisted_2 = { class: "d-flex align-items-center fs-5 fw-bolder mb-4" }
const _hoisted_3 = { class: "row mb-6" }
const _hoisted_4 = { class: "col-md-12" }
const _hoisted_5 = { class: "d-flex align-items-center fs-6 fw-bold mb-2" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-12" }
const _hoisted_8 = { class: "d-flex align-items-center fs-6 fw-bold mb-2" }
const _hoisted_9 = { class: "upload-image-box" }
const _hoisted_10 = { class: "upload-box" }
const _hoisted_11 = { class: "add-image" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-file-pdf" })
], -1)
const _hoisted_13 = { class: "uploaded-image-area" }
const _hoisted_14 = { class: "uploaded-images mb-6" }
const _hoisted_15 = { class: "image-box datasheet-preview" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "datasheet-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-file-pdf fa-3x" })
], -1)
const _hoisted_17 = { class: "image-heading" }
const _hoisted_18 = /*#__PURE__*/_createVNode("i", { class: "fas fa-external-link-alt" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode("   ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_col = _resolveComponent("el-col")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_InnerLoader, {
      loading: _ctx.loading,
      innerLoading: true
    }, null, 8, ["loading"]),
    _createVNode("div", _hoisted_1, [
      _createVNode("label", _hoisted_2, _toDisplayString(_ctx.$t('message.DATA_SHEET_MANUAL')), 1),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('message.SHAREPOINT_URL')), 1),
          _createVNode(_component_el_input, {
            modelValue: _ctx.datasheetUrl,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.datasheetUrl = $event)),
            type: "url",
            placeholder: _ctx.$t('message.ENTER_SHAREPOINT_URL'),
            onInput: _ctx.emitChange
          }, null, 8, ["modelValue", "placeholder", "onInput"])
        ])
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, [
          _createVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('message.UPLOAD_PDF')), 1),
          _createVNode("div", _hoisted_9, [
            _withDirectives(_createVNode("div", _hoisted_10, [
              _createVNode("div", _hoisted_11, [
                _createVNode("input", {
                  type: "file",
                  class: "upload-btn",
                  accept: "application/pdf,.pdf",
                  onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onPdfChange && _ctx.onPdfChange(...args)))
                }, null, 32),
                _hoisted_12,
                _createVNode("strong", null, _toDisplayString(_ctx.$t('message.UPLOAD_PDF')), 1),
                _createVNode("span", null, "PDF " + _toDisplayString(_ctx.$t('message.FORMAT')) + " (max 5MB)", 1)
              ])
            ], 512), [
              [_vShow, !_ctx.preview]
            ]),
            _withDirectives(_createVNode("div", _hoisted_13, [
              _createVNode(_component_el_col, { span: 8 }, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_14, [
                    _createVNode("div", _hoisted_15, [
                      _hoisted_16,
                      _createVNode("span", _hoisted_17, [
                        (_ctx.preview?.src)
                          ? (_openBlock(), _createBlock("a", {
                              key: 0,
                              href: _ctx.preview.src,
                              target: "_blank",
                              rel: "noopener noreferrer"
                            }, [
                              _hoisted_18
                            ], 8, ["href"]))
                          : _createCommentVNode("", true),
                        _hoisted_19,
                        _createVNode("i", {
                          class: "fas fa-trash-alt",
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.removePdf && _ctx.removePdf(...args)))
                        })
                      ])
                    ]),
                    _createVNode("div", {
                      class: "cover-image-text text-truncate",
                      title: _ctx.preview?.name
                    }, _toDisplayString(_ctx.preview?.name || _ctx.$t('message.DATA_SHEET_MANUAL')), 9, ["title"])
                  ])
                ]),
                _: 1
              })
            ], 512), [
              [_vShow, _ctx.preview]
            ])
          ])
        ])
      ])
    ])
  ], 64))
})